// extracted by mini-css-extract-plugin
module.exports = {"root":"EditMenuDescriptionPanel_root__1l1u3","form":"EditMenuDescriptionPanel_form__1hlka","title":"EditMenuDescriptionPanel_title__3NNKy"};